<template>
  <omint-page>
    <Header
      name="Minhas solicitações"
      :titleLabel="title"
    />
    <router-view />
    <Footer />
  </omint-page>
</template>

<script>
import Header from "@/components/Molecules/Header";
import Footer from "@/components/Molecules/Footer";

export default {
  name: "MyRequests",
  components: {
    Header,
    Footer
  },
  computed: {
    title() {
      return this.$route.query?.tipo === "pedido" ? "Pedido médico" : "Minhas solicitações";
    }
  }
};
</script>
